import React from 'react';
import { AutoScrollbars, Button, Filters, Icons } from 'components';
import { actions as containersActions, IFilter } from 'services/containers/containers-service';
import { HelpButtonWithPopover } from 'components/help-button';
import { useSelector } from 'react-redux';
import { getHints } from 'selectors';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';

export interface IListFiltersProps {
    containerCode: string;
    contFilters: IFilter[]
}

const ListFiltersComponent: React.FC<IListFiltersProps> = (props): JSX.Element => {
    const { containerCode, contFilters } = props;

    const hints = useSelector(getHints);
    const { t } = useTranslation();

    const handleFilterChange = (filterId, value, debounced = false) => {
        const payload = {
            code: containerCode,
            id: filterId,
            value
        };

        if (debounced) {
            containersActions.setFilterDebounced(payload);
        } else {
            containersActions.setFilter(payload);
        }
    };

    const renderHelpButton = (code: string) => {
        const hint = hints.find(obj => obj.get('code') === `${code}_filter`);
        if (hint) {
            const { title, text } = hint['_attributes'];
            return (
                <HelpButtonWithPopover
                    className="for-objects-list"
                    popoverProps={{
                        placement: 'bottom',
                        className: 'help-button-popover bottom-placement'
                    }}
                    offset={[ 0, 24 ]}
                >
                    <div className="header">
                        {title}
                    </div>
                    <div className="body">
                        {text}
                    </div>
                </HelpButtonWithPopover>
            );
        }

        return null;
    };

    return (
        <>
            <div className="object-list-filters__header">
                {t('Фильтры')}
                {!isMobile && renderHelpButton(containerCode)}
            </div>
            <div className="object-list-filters__wrapper">
                <AutoScrollbars>
                    <div className="object-list-filters__items">
                        {contFilters.map((filter) => {
                            let FilterComponent = Filters[filter.type];
                            if (!FilterComponent) return null;
                            const options = {};
                            if (filter.type === 'powers') {
                                options['steps'] = [ 1, 3, 6 ];
                            } else if (filter.type === 'gas') {
                                options['steps'] = [ 2, 5, 10 ];
                                options['minValue'] = 0;
                            }
                            return (
                                <FilterComponent
                                    key={filter.id}
                                    filter={filter}
                                    onFilterChange={handleFilterChange}
                                    {...options}
                                />
                            );
                        })}
                    </div>
                </AutoScrollbars>
            </div>
            <div className="object-list-filters__footer">
                <Button
                    text={t('Cбросить фильтр')}
                    title={t('Cбросить фильтр')}
                    onClick={() => {
                        containersActions.clearFiltersByLayerCode(containerCode);
                    }}
                    icon={<Icons.IconGarbageBin2 />}
                />
            </div>
        </>
    );
};

export const ListFilters = ListFiltersComponent;
